import { render, staticRenderFns } from "./FileStat.vue?vue&type=template&id=8f4168fe&scoped=true"
import script from "./FileStat.vue?vue&type=script&lang=js"
export * from "./FileStat.vue?vue&type=script&lang=js"
import style0 from "./FileStat.vue?vue&type=style&index=0&id=8f4168fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4168fe",
  null
  
)

export default component.exports